module.exports = __webpack_public_path__ + "media/Floete.e433b6ab.mp3";